import { RouteObject } from 'react-router-dom'

import AuthTemplate from '@/templates/AuthTemplate'

import AuthPage from '@/pages/Auth/Auth'
import AuthLoginPage from '@/pages/Auth/Login'
import AuthRegisterPage from '@/pages/Auth/Register'
import AuthForgotPassword from '@/pages/Auth/ForgotPassword'
import AuthNewPassword from '@/pages/Auth/NewPassword'

import { AppRoutes } from './types/routes'

export const authRoutes: RouteObject = {
  path: AppRoutes.AUTH,
  element: <AuthTemplate />,
  children: [
    { index: true, element: <AuthPage /> },
    { path: AppRoutes.LOGIN, element: <AuthLoginPage /> },
    { path: AppRoutes.REGISTER, element: <AuthRegisterPage /> },
    { path: AppRoutes.FORGOT_PASSWORD, element: <AuthForgotPassword /> },
    { path: AppRoutes.NEW_PASSWORD, element: <AuthNewPassword /> },
  ],
}
